// extracted by mini-css-extract-plugin
var _1 = "_YAZJ";
export { _1 as "tabs" }
